import $ from './touch'
let addHtml = {

	//页面加载html
	loadingHtml: '<div id="auour_loading" class="loading">' +
		'<div class="load-mid">' +
		'<p>正在加载⋯</p>' +
		'</div>' +
		'</div>',

	//提示html
	showToast: '<div class="toast-mask"></div>' +
		'<div id="i_toast_show" class="toast-content"></div>',

	//提示html
	showToastWhite: '<div class="toast-mask"></div>' +
		'<div id="i_toast_white_show" class="toast-content" style="background:#fff;color: #000;padding:20px"></div>',

	//确认html
	comfirmToast: '<div id="i_comfirm_toast" class="toast-body">' +
		'<div class="toast-msg"></div>' +
		'<div class="toast-confirm toast-btn"></div>' +
		'</div>',
    //输入密码的遮罩不需要了
	//输入密码
	// passwordToast: '<div class="toast-body hide" id="i_password_toast" ><div class="white-bg toast-main border-radius-10"> <span class="toast_del"><img style="max-width: 20px" src="./app/image/order/X.png" alt=""></span>' +
	// 	'<div class="text-center toast-msg">请输入您的支付密码</div> ' +
	// 	'<div class="password-box"> ' +
	// 	'<p class="text-center box" style="margin:0 10px"><span></span> ' +
	// 	'<span></span> ' +
	// 	'<span></span> ' +
	// 	'<span></span> ' +
	// 	'<span></span> ' +
	// 	'<span></span> </p> ' +
	// 	'<div class="password-input-box"> ' +
	// 	'<input type="password" id="password_toast_input" maxlength="6" readonlyunselectable="on" > ' +
	// 	'</div><p style="line-height: 40px;padding-right: 10px" class="text-right"><a href="./modifyPayment.html" class="min-text blue">忘记密码</a></p>' +
	// 	'</div>' +
	// 	'<div class="toast-btn blue password-box-btn"><span>确定</span></div></div></div>',

	//确认取消html
	toComfirmToast: '<div id="i_check_toast" class="toast-body hide">' +
		'<div class="toast-msg"></div>' +
		'<div class="box">' +
		'<div class="toast-btn toast-back cell-bl-1"><span>取消</span></div>' +
		'<div class="toast-btn cell-bl-1 toast-check"><span>确定</span></div>' +
		'</div></div>',

	//浏览器指向图片
	// toOther: '<img id="i_other" class="other-img" src="./app/image/home/share.png">',

	//页面滑出
	page: '<div id="i_page"></div>',
	//保持弹出
	toKeepToast: '<div id="i_keep_toast" class="toast-keep border-radius-5 toast-body"></div>',
	share: '<div id="i_share" class="share-content"></div>'
};
let html = '';
for(var h in addHtml) {
	html += addHtml[h];
}
$('body').append(html);

let toast = {
	/**
	 *
	 *  */
	passwordToast: function(callback, param) {
		var _this = this;
		var passwordInpt = $("#password_toast_input");
		passwordInpt.val("");
		$('.password-box span').text("");
		this.mask.show();
		this.password.show();
		passwordInpt.off().on('keyup', _toBlur);
		this.delete.off().on('click', function() {
			_this.toHide();
		});
		var params = param ? param : {};
		$(".password-box-btn").off().on('click', function() {
			params.password = passwordInpt.val();
			if(params.password.length == 6) {
				_this.toHide();
				if(callback && Object.prototype.toString.call(callback) === '[object Function]')
					callback.apply(_this, [params]);
			}
		});
	},
	/**
	 * 视图弹出层
	 * @html 显示html文案
	 * @callback 回调函数
	 * @param 回调函数所需参数
	 * */
	showToast: function(html, callback, param) {
		var _this = this;
		this.mask.show();
		this.showContent.show().html(html);
		setTimeout(function() {
			_this.hide(callback, param);
		}, 1500);
	},
	/**
	 * 白色视图弹出层
	 * @html 显示html文案
	 * @callback 回调函数
	 * @param 回调函数所需参数
	 * */
	showToastWhite: function(html, callback, param) {
		var _this = this;
		this.mask.show();
		this.showContentWhite.show().html(html);
		this.mask.off().on('click', function() {
			_this.hide(callback, param);
		}).on('touchmove', function(e) {
			e.preventDefault(); //阻止默认行为
		})
	},

	/**
	 * 确认弹出层
	 * @html 显示html文案
	 * @btn 按钮数组 例:{cancel:'xx',confirm:'xx'}
	 * @callback 回调函数
	 * @param 回调函数所需参数
	 * */
	_showConfirm: function(html, btn, callback, param) {
		var _this = this;
		this.mask.show();
		this.check.show();
		this.msg.html(html);
		this.back.html(btn.cancel).off().on('click', function() {
			_this.hide();
		});
		this.confirm.html(btn.confirm).off().on('click', function() {
			_this.hide(callback, param);
		});
	},

	/**
	 * 确认取消弹出层
	 * @html 显示html文案
	 * @btn 按钮数组 例:'知道了'
	 * @callback 回调函数
	 * @param 回调函数所需参数
	 * */
	_showCheck: function(html, btn, callback, param) {
		var _this = this;
		this.mask.show();
		this.toComfirm.show();
		this.msg.html(html);
		this.confirm.html(btn).off().on('click', function() {
			_this.hide(callback, param);
		});
	},

	/**
	 * 页面滑动层
	 * @html 显示html文案
	 * */
	_showPage: function(html) {
		this.page.html(html);
		setTimeout(function() {
			$(".page").addClass('all').find('.header-return-img').show().off().on('click',
				function() {
					$(this).hide();
					$(".page").removeClass('all');
				}
			);
		}, 200)
	},

	/**
	 *  查看弹出层
	 *  @html 显示html文案
	 * */
	_showKeepToast: function(html) {
		var _this = this;
		this.mask.show().on('click', function() {
			_this.toHide()
		});
		this.keep.show().html(html);
	},

	/**
	 * 回调影藏
	 * @callback 回调函数
	 * @param 回调函数所需参数
	 * */
	hide: function(callback, param) {
		var _this = this;
		if(callback && Object.prototype.toString.call(callback) === '[object Function]') {
			callback.apply(_this, [param]);
		} else {
			this.toHide();
		}
	},

	/**
	 * 影藏弹出层
	 * */
	toHide: function() {
		this.mask.hide();
		this.content.hide();
	},

	/**
	 * 分享图层显示
	 * */
	shareToast: function() {
		var _this = this;
		this.mask.show();
		this.share.show();
		this.mask.off().on('click', function() {
			_this.toHide();
		})
		$('.share-cancle').off().on('click', function() {
			_this.toHide();
		})
	},

	/**
	 * 跳转其他浏览器显示
	 * */
	showOtherToast: function(b) {
		var _this = this;
		this.mask.show();
		this.other.show();
		if(!b) {
			this.mask.off().on('click', function() {
				_this.hide();
			})
		}
	}
}
$.extend(toast, {
	mask: $(".toast-mask"),
	content: $(".toast-content,.toast-body,.toast-keep,.share-content,.other-img"),
	showContent: $("#i_toast_show"),
	showContentWhite: $("#i_toast_white_show"),
	confirm: $(".toast-confirm, .toast-check"),
	check: $("#i_check_toast"),
	toComfirm: $("#i_comfirm_toast"),
	msg: $(".toast-msg"),
	back: $(".toast-back"),
	keep: $("#i_keep_toast"),
	page: $("#i_page"),
	password: $("#i_password_toast"),
	delete: $(".toast_del"),
	share: $("#i_share"),
	other: $("#i_other"),
});
window.toast = toast;

function _toBlur() {
	let val = $(event.currentTarget).val();
	let len = val.length;
	for(var i = 0; i < 6; i++) {
		if(i < len) {
			$(".password-box .box span").eq(i).text('●');
		} else {
			$(".password-box .box span").eq(i).text("");
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/toast.js